import { AddIcon, HamburgerIcon } from "@chakra-ui/icons";
import { Box, Button, Container, Flex, IconButton, Menu, MenuButton, MenuItem, MenuList, Spacer } from "@chakra-ui/react"
import { useNavigate } from "react-router-dom";

const MenuNavbar = () => {

    const navigate = useNavigate()

    const handleLogout = () => {

        localStorage.clear()

        navigate('/login')
    }

    return (
        <Container mt={10} maxW='5xl' >

            <Flex minWidth='max-content' alignItems='center'>
                <Box></Box>
                <Spacer />
                <Menu placement="top-end">
                    <MenuButton
                        as={Button}
                        aria-label='Options'
                        rightIcon={<HamburgerIcon />}
                        variant='solid'
                        width={100}
                        colorScheme="brand"
                    >
                        Menu
                    </MenuButton>
                    <MenuList>
                        <MenuItem onClick={() => navigate('/user/list')}>
                            Lista de usuarios
                        </MenuItem>
                        <MenuItem  onClick={() => navigate('/payment/list')}>
                            Lista de pago
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                           Cerrar sesión
                        </MenuItem>
                    </MenuList>
                </Menu>
            </Flex>
        </Container>
    )
};

export default MenuNavbar